import { Injectable, signal } from '@angular/core';

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

@Injectable({ providedIn: 'root' })
export class InstallPromptService {
  private deferredEvent: BeforeInstallPromptEvent | null = null;
  readonly canInstall = signal(false);
  readonly isStandalone = signal(this.detectStandalone());
  readonly isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent) && !(window as unknown as { MSStream?: unknown }).MSStream;

  constructor() {
    window.addEventListener('beforeinstallprompt', (e: Event) => {
      e.preventDefault();
      this.deferredEvent = e as BeforeInstallPromptEvent;
      this.canInstall.set(true);
    });
    window.addEventListener('appinstalled', () => {
      this.deferredEvent = null;
      this.canInstall.set(false);
      this.isStandalone.set(true);
    });
  }

  async promptInstall(): Promise<void> {
    if (!this.deferredEvent) return;
    await this.deferredEvent.prompt();
    await this.deferredEvent.userChoice;
    this.deferredEvent = null;
    this.canInstall.set(false);
  }

  private detectStandalone(): boolean {
    const nav = navigator as unknown as { standalone?: boolean };
    return window.matchMedia?.('(display-mode: standalone)').matches === true || nav.standalone === true;
  }
}
